export const evolutionFamiliesByDex = {
  // ===== GEN 1 =====
  1: [1, 2, 3], 2: [1, 2, 3], 3: [1, 2, 3],
  4: [4, 5, 6], 5: [4, 5, 6], 6: [4, 5, 6],
  7: [7, 8, 9], 8: [7, 8, 9], 9: [7, 8, 9],
  10: [10, 11, 12], 11: [10, 11, 12], 12: [10, 11, 12],
  13: [13, 14, 15], 14: [13, 14, 15], 15: [13, 14, 15],
  16: [16, 17, 18], 17: [16, 17, 18], 18: [16, 17, 18],
  19: [19, 20], 20: [19, 20],
  21: [21, 22], 22: [21, 22],
  23: [23, 24], 24: [23, 24],
  25: [25, 26], 26: [25, 26],
  27: [27, 28], 28: [27, 28],
  29: [29, 30, 31], 30: [29, 30, 31], 31: [29, 30, 31],
  32: [32, 33, 34], 33: [32, 33, 34], 34: [32, 33, 34],
  35: [35, 36], 36: [35, 36],
  37: [37, 38], 38: [37, 38],
  39: [39, 40], 40: [39, 40],
  41: [41, 42], 42: [41, 42],
  43: [43, 44, 45], 44: [43, 44, 45], 45: [43, 44, 45],
  46: [46, 47], 47: [46, 47],
  48: [48, 49], 49: [48, 49],
  50: [50, 51], 51: [50, 51],
  52: [52, 53], 53: [52, 53],
  54: [54, 55], 55: [54, 55],
  56: [56, 57], 57: [56, 57],
  58: [58, 59], 59: [58, 59],
  60: [60, 61, 62], 61: [60, 61, 62], 62: [60, 61, 62],
  63: [63, 64, 65], 64: [63, 64, 65], 65: [63, 64, 65],
  66: [66, 67, 68], 67: [66, 67, 68], 68: [66, 67, 68],
  69: [69, 70, 71], 70: [69, 70, 71], 71: [69, 70, 71],
  72: [72, 73], 73: [72, 73],
  74: [74, 75, 76], 75: [74, 75, 76], 76: [74, 75, 76],
  77: [77, 78], 78: [77, 78],
  79: [79, 80], 80: [79, 80],
  81: [81, 82], 82: [81, 82],
  84: [84, 85], 85: [84, 85],
  86: [86, 87], 87: [86, 87],
  88: [88, 89], 89: [88, 89],
  90: [90, 91], 91: [90, 91],
  92: [92, 93, 94], 93: [92, 93, 94], 94: [92, 93, 94],
  96: [96, 97], 97: [96, 97],
  98: [98, 99], 99: [98, 99],
  100: [100, 101], 101: [100, 101],
  102: [102, 103], 103: [102, 103],
  104: [104, 105], 105: [104, 105],
  109: [109, 110], 110: [109, 110],
  111: [111, 112], 112: [111, 112],
  116: [116, 117], 117: [116, 117],
  118: [118, 119], 119: [118, 119],
  120: [120, 121], 121: [120, 121],
  129: [129, 130], 130: [129, 130],
  133: [133, 134, 135, 136],
  134: [133, 134, 135, 136],
  135: [133, 134, 135, 136],
  136: [133, 134, 135, 136],
  138: [138, 139], 139: [138, 139],
  140: [140, 141], 141: [140, 141],
  147: [147, 148, 149], 148: [147, 148, 149], 149: [147, 148, 149],

  // ===== GEN 2 =====
  152: [152, 153, 154], 153: [152, 153, 154], 154: [152, 153, 154],
  155: [155, 156, 157], 156: [155, 156, 157], 157: [155, 156, 157],
  158: [158, 159, 160], 159: [158, 159, 160], 160: [158, 159, 160],
  161: [161, 162], 162: [161, 162],
  163: [163, 164], 164: [163, 164],
  165: [165, 166], 166: [165, 166],
  167: [167, 168], 168: [167, 168],
  170: [170, 171], 171: [170, 171],
  172: [172, 25, 26], // Pichu Linie
  173: [173, 35, 36],
  174: [174, 39, 40],
  175: [175, 176],
  177: [177, 178], 178: [177, 178],
  179: [179, 180, 181], 180: [179, 180, 181], 181: [179, 180, 181],
  183: [183, 184], 184: [183, 184],
  185: [185],
  187: [187, 188, 189], 188: [187, 188, 189], 189: [187, 188, 189],
  190: [190],
  191: [191, 192], 192: [191, 192],
  193: [193],
  194: [194, 195], 195: [194, 195],
  196: [133, 196],
  197: [133, 197],
  198: [198],
  199: [79, 199],
  200: [200],
  201: [201],
  202: [202],
  203: [203],
  204: [204, 205], 205: [204, 205],
  206: [206],
  207: [207],
  208: [208],
  209: [209, 210], 210: [209, 210],
  211: [211],
  213: [213],
  214: [214],
  215: [215],
  216: [216, 217], 217: [216, 217],
  218: [218, 219], 219: [218, 219],
  220: [220, 221], 221: [220, 221],
  222: [222],
  223: [223, 224], 224: [223, 224],
  225: [225],
  226: [226],
  227: [227],
  228: [228, 229], 229: [228, 229],
  231: [231, 232], 232: [231, 232],
  233: [137, 233],
  234: [234],
  235: [235],
  236: [236, 106, 107, 237],
  238: [238, 124],
  239: [239, 125],
  240: [240, 126],
  241: [241],
  242: [113, 242],
  246: [246, 247, 248], 247: [246, 247, 248], 248: [246, 247, 248],

  // ===== GEN 3 =====
  252: [252, 253, 254], 253: [252, 253, 254], 254: [252, 253, 254],
  255: [255, 256, 257], 256: [255, 256, 257], 257: [255, 256, 257],
  258: [258, 259, 260], 259: [258, 259, 260], 260: [258, 259, 260],
  261: [261, 262], 262: [261, 262],
  263: [263, 264], 264: [263, 264],
  265: [265, 266, 267], 266: [265, 266, 267], 267: [265, 266, 267],
  268: [268, 269],
  270: [270, 271, 272], 271: [270, 271, 272], 272: [270, 271, 272],
  273: [273, 274, 275], 274: [273, 274, 275], 275: [273, 274, 275],
  276: [276, 277], 277: [276, 277],
  278: [278, 279], 279: [278, 279],
  280: [280, 281, 282], 281: [280, 281, 282], 282: [280, 281, 282],
  283: [283, 284], 284: [283, 284],
  285: [285, 286], 286: [285, 286],
  287: [287, 288, 289], 288: [287, 288, 289], 289: [287, 288, 289],
  290: [290, 291, 292],
  293: [293, 294, 295], 294: [293, 294, 295], 295: [293, 294, 295],
  296: [296, 297], 297: [296, 297],
  298: [298, 183, 184],
  299: [299, 476],
  300: [300, 301],
  304: [304, 305, 306], 305: [304, 305, 306], 306: [304, 305, 306],
  307: [307, 308], 308: [307, 308],
  309: [309, 310], 310: [309, 310],
  315: [315],
  316: [316, 317], 317: [316, 317],
  318: [318, 319], 319: [318, 319],
  320: [320, 321], 321: [320, 321],
  322: [322, 323], 323: [322, 323],
  325: [325, 326], 326: [325, 326],
  328: [328, 329, 330], 329: [328, 329, 330], 330: [328, 329, 330],
  331: [331, 332], 332: [331, 332],
  333: [333, 334], 334: [333, 334],
  335: [335],
  336: [336],
  337: [337],
  338: [338],
  339: [339, 340], 340: [339, 340],
  341: [341, 342], 342: [341, 342],
  343: [343, 344], 344: [343, 344],
  345: [345, 346], 346: [345, 346],
  347: [347, 348], 348: [347, 348],
  349: [349, 350], 350: [349, 350],
  353: [353, 354], 354: [353, 354],
  355: [355, 356], 356: [355, 356],
  360: [360, 202],
  361: [361, 362], 362: [361, 362],
  363: [363, 364, 365], 364: [363, 364, 365], 365: [363, 364, 365],
  366: [366, 367, 368],
  371: [371, 372, 373], 372: [371, 372, 373], 373: [371, 372, 373],
  374: [374, 375, 376], 375: [374, 375, 376], 376: [374, 375, 376],

  // ===== GEN 4 =====
  387: [387, 388, 389], 388: [387, 388, 389], 389: [387, 388, 389],
  390: [390, 391, 392], 391: [390, 391, 392], 392: [390, 391, 392],
  393: [393, 394, 395], 394: [393, 394, 395], 395: [393, 394, 395],
  396: [396, 397, 398], 397: [396, 397, 398], 398: [396, 397, 398],
  399: [399, 400], 400: [399, 400],
  401: [401, 402], 402: [401, 402],
  403: [403, 404, 405], 404: [403, 404, 405], 405: [403, 404, 405],
  406: [406, 315],
  408: [408, 409], 409: [408, 409],
  410: [410, 411], 411: [410, 411],
  412: [412, 413, 414],
  415: [415, 416],
  418: [418, 419], 419: [418, 419],
  420: [420, 421], 421: [420, 421],
  422: [422, 423], 423: [422, 423],
  425: [425, 426], 426: [425, 426],
  427: [427, 428], 428: [427, 428],
  429: [200, 429],
  431: [431, 432], 432: [431, 432],
  433: [433, 358],
  434: [434, 435], 435: [434, 435],
  436: [436, 437], 437: [436, 437],
  438: [438, 185],
  439: [439, 122],
  440: [440, 113, 242],
  443: [443, 444, 445], 444: [443, 444, 445], 445: [443, 444, 445],
  446: [446, 143],
  447: [447, 448],
  449: [449, 450], 450: [449, 450],
  451: [451, 452], 452: [451, 452],
  453: [453, 454], 454: [453, 454],
  456: [456, 457], 457: [456, 457],
  458: [458, 226],
  459: [459, 460], 460: [459, 460],

  // ===== GEN 5 =====
  495: [495, 496, 497], 496: [495, 496, 497], 497: [495, 496, 497],
  498: [498, 499, 500], 499: [498, 499, 500], 500: [498, 499, 500],
  501: [501, 502, 503], 502: [501, 502, 503], 503: [501, 502, 503],
  504: [504, 505], 505: [504, 505],
  506: [506, 507, 508], 507: [506, 507, 508], 508: [506, 507, 508],
  509: [509, 510], 510: [509, 510],
  511: [511, 512], 512: [511, 512],
  513: [513, 514], 514: [513, 514],
  515: [515, 516], 516: [515, 516],
  517: [517, 518], 518: [517, 518],
  519: [519, 520, 521], 520: [519, 520, 521], 521: [519, 520, 521],
  522: [522, 523], 523: [522, 523],
  524: [524, 525, 526], 525: [524, 525, 526], 526: [524, 525, 526],
  527: [527, 528], 528: [527, 528],
  529: [529, 530], 530: [529, 530],
  532: [532, 533, 534], 533: [532, 533, 534], 534: [532, 533, 534],
  535: [535, 536, 537], 536: [535, 536, 537], 537: [535, 536, 537],
  540: [540, 541, 542], 541: [540, 541, 542], 542: [540, 541, 542],
  543: [543, 544, 545], 544: [543, 544, 545], 545: [543, 544, 545],
  546: [546, 547], 547: [546, 547],
  548: [548, 549], 549: [548, 549],
  551: [551, 552, 553], 552: [551, 552, 553], 553: [551, 552, 553],
  554: [554, 555], 555: [554, 555],
  557: [557, 558], 558: [557, 558],
  559: [559, 560], 560: [559, 560],
  562: [562, 563], 563: [562, 563],
  568: [568, 569], 569: [568, 569],
  570: [570, 571], 571: [570, 571],
  572: [572, 573], 573: [572, 573],
  574: [574, 575, 576], 575: [574, 575, 576], 576: [574, 575, 576],
  577: [577, 578, 579], 578: [577, 578, 579], 579: [577, 578, 579],
  580: [580, 581], 581: [580, 581],
  582: [582, 583, 584], 583: [582, 583, 584], 584: [582, 583, 584],
  585: [585, 586], 586: [585, 586],
  588: [588, 589], 589: [588, 589],
  590: [590, 591], 591: [590, 591],
  592: [592, 593], 593: [592, 593],
  595: [595, 596], 596: [595, 596],
  597: [597, 598], 598: [597, 598],
  599: [599, 600, 601], 600: [599, 600, 601], 601: [599, 600, 601],
  602: [602, 603, 604], 603: [602, 603, 604], 604: [602, 603, 604],
  607: [607, 608, 609], 608: [607, 608, 609], 609: [607, 608, 609],
  610: [610, 611, 612], 611: [610, 611, 612], 612: [610, 611, 612],
  613: [613, 614], 614: [613, 614],
  616: [616, 617], 617: [616, 617],
  619: [619, 620], 620: [619, 620],
  622: [622, 623], 623: [622, 623],
  624: [624, 625], 625: [624, 625],
  627: [627, 628], 628: [627, 628],
  629: [629, 630], 630: [629, 630],
  633: [633, 634, 635], 634: [633, 634, 635], 635: [633, 634, 635],
  // ===== GEN 6 =====
636: [636, 637], 637: [636, 637],
650: [650, 651, 652], 651: [650, 651, 652], 652: [650, 651, 652],
653: [653, 654, 655], 654: [653, 654, 655], 655: [653, 654, 655],
656: [656, 657, 658], 657: [656, 657, 658], 658: [656, 657, 658],
659: [659, 660], 660: [659, 660],
661: [661, 662, 663], 662: [661, 662, 663], 663: [661, 662, 663],
664: [664, 665, 666], 665: [664, 665, 666], 666: [664, 665, 666],
667: [667, 668], 668: [667, 668],
669: [669, 670, 671], 670: [669, 670, 671], 671: [669, 670, 671],
672: [672, 673], 673: [672, 673],
674: [674, 675], 675: [674, 675],
676: [676],
677: [677, 678], 678: [677, 678],
679: [679, 680, 681], 680: [679, 680, 681], 681: [679, 680, 681],
682: [682, 683], 683: [682, 683],684: [684, 685], 685: [684, 685],
686: [686, 687], 687: [686, 687],
688: [688, 689], 689: [688, 689],
690: [690, 691], 691: [690, 691],
692: [692, 693], 693: [692, 693],
694: [694, 695], 695: [694, 695],
696: [696, 697], 697: [696, 697],
698: [698, 699], 699: [698, 699],
700: [133, 700], // Feelinara gehört zur Evoli-Linie
701: [701],
702: [702],
703: [703],
704: [704, 705, 706], 705: [704, 705, 706], 706: [704, 705, 706],
707: [707],
708: [708, 709], 709: [708, 709],
710: [710, 711], 711: [710, 711],
712: [712, 713], 713: [712, 713],
714: [714, 715], 715: [714, 715],
// ===== GEN 7 =====
722: [722, 723, 724], 723: [722, 723, 724], 724: [722, 723, 724],
725: [725, 726, 727], 726: [725, 726, 727], 727: [725, 726, 727],
728: [728, 729, 730], 729: [728, 729, 730], 730: [728, 729, 730],

731: [731, 732, 733], 732: [731, 732, 733], 733: [731, 732, 733],
734: [734, 735], 735: [734, 735],
736: [736, 737, 738], 737: [736, 737, 738], 738: [736, 737, 738],
739: [739, 740], 740: [739, 740],
741: [741],
742: [742, 743], 743: [742, 743],
744: [744, 745], 745: [744, 745],
746: [746],
747: [747, 748], 748: [747, 748],
749: [749, 750], 750: [749, 750],
751: [751, 752], 752: [751, 752],
753: [753, 754], 754: [753, 754],
755: [755, 756], 756: [755, 756],
757: [757, 758], 758: [757, 758],
759: [759, 760], 760: [759, 760],
761: [761, 762, 763], 762: [761, 762, 763], 763: [761, 762, 763],
764: [764],
765: [765],
766: [766],
767: [767, 768], 768: [767, 768],
769: [769, 770], 770: [769, 770],
771: [771],
772: [772, 773], 773: [772, 773],
774: [774],
775: [775],
776: [776],
777: [777],
778: [778],
779: [779],
780: [780],
781: [781],
782: [782, 783, 784], 783: [782, 783, 784], 784: [782, 783, 784],
785: [785],
786: [786],
787: [787],
788: [788],
789: [789, 790, 791, 792, 800], 790: [789, 790, 791, 792, 800],
791: [789, 790, 791, 792, 800], 792: [789, 790, 791, 792, 800], 800: [789, 790, 791, 792, 800],
793: [793],
794: [794],
795: [795],
796: [796],
797: [797],
798: [798],
799: [799],
801: [801],
802: [802],
803: [803, 804], 804: [803, 804],
805: [805],
806: [806],
807: [807],
808: [808, 809], 809: [808, 809],

// ===== GEN 8 =====
810: [810, 811, 812], 811: [810, 811, 812], 812: [810, 811, 812],
813: [813, 814, 815], 814: [813, 814, 815], 815: [813, 814, 815],
816: [816, 817, 818], 817: [816, 817, 818], 818: [816, 817, 818],

819: [819, 820], 820: [819, 820],
821: [821, 822, 823], 822: [821, 822, 823], 823: [821, 822, 823],
824: [824, 825, 826], 825: [824, 825, 826], 826: [824, 825, 826],
827: [827, 828], 828: [827, 828],
829: [829, 830], 830: [829, 830],
831: [831, 832], 832: [831, 832],
833: [833, 834], 834: [833, 834],
835: [835, 836], 836: [835, 836],
837: [837, 838, 839], 838: [837, 838, 839], 839: [837, 838, 839],
840: [840, 841, 842], 841: [840, 841, 842], 842: [840, 841, 842],
843: [843, 844], 844: [843, 844],
845: [845],
846: [846, 847], 847: [846, 847],
848: [848, 849], 849: [848, 849],
850: [850, 851], 851: [850, 851],
852: [852, 853], 853: [852, 853],
854: [854, 855], 855: [854, 855],
856: [856, 857, 858], 857: [856, 857, 858], 858: [856, 857, 858],
859: [859, 860, 861], 860: [859, 860, 861], 861: [859, 860, 861],
862: [263, 264, 862],
863: [52, 863],
864: [222, 864],
865: [83, 865],
866: [122, 866],
867: [562, 867],
868: [868, 869], 869: [868, 869],
870: [870],
871: [871],
872: [872, 873], 873: [872, 873],
874: [874],
875: [875],
876: [876],
877: [877],
878: [878, 879], 879: [878, 879],
880: [880],
881: [881],
882: [882],
883: [883],
884: [884],
885: [885, 886, 887], 886: [885, 886, 887], 887: [885, 886, 887],
888: [888],
889: [889],
890: [890],
891: [891, 892], 892: [891, 892],
893: [893],
894: [894],
895: [895],
896: [896],
897: [897],
898: [898],
899: [234, 899],
900: [215, 900],
901: [216, 217, 901],
902: [550, 902],
903: [194, 195, 903],
904: [211, 904],
905: [905],

// ===== GEN 9 =====
906: [906, 907, 908], 907: [906, 907, 908], 908: [906, 907, 908],
909: [909, 910, 911], 910: [909, 910, 911], 911: [909, 910, 911],
912: [912, 913, 914], 913: [912, 913, 914], 914: [912, 913, 914],

915: [915, 916], 916: [915, 916],
917: [917, 918], 918: [917, 918],
919: [919, 920], 920: [919, 920],
921: [921, 922, 923], 922: [921, 922, 923], 923: [921, 922, 923],
924: [924, 925], 925: [924, 925],
926: [926, 927], 927: [926, 927],
928: [928, 929, 930], 929: [928, 929, 930], 930: [928, 929, 930],
931: [931],
932: [932, 933, 934], 933: [932, 933, 934], 934: [932, 933, 934],
935: [935, 936, 937], 936: [935, 936, 937], 937: [935, 936, 937],
938: [938, 939], 939: [938, 939],
940: [940, 941], 941: [940, 941],
942: [942, 943], 943: [942, 943],
944: [944, 945], 945: [944, 945],
946: [946, 947], 947: [946, 947],
948: [948, 949], 949: [948, 949],
950: [950],
951: [951, 952], 952: [951, 952],
953: [953, 954], 954: [953, 954],
955: [955, 956], 956: [955, 956],
957: [957, 958, 959], 958: [957, 958, 959], 959: [957, 958, 959],
960: [960, 961], 961: [960, 961],
962: [962],
963: [963, 964], 964: [963, 964],
965: [965],
966: [966],
967: [967],
968: [968],
969: [969, 970], 970: [969, 970],
971: [971],
972: [972, 973], 973: [972, 973],
974: [974, 975], 975: [974, 975],
976: [976],
977: [977],
978: [978],
979: [979],
980: [980],
981: [981],
982: [982],
983: [983],
984: [984],
985: [985],
986: [986],
987: [987],
988: [988],
989: [989],
990: [990],
991: [991],
992: [992],
993: [993],
994: [994],
995: [995],
996: [996, 997, 998], 997: [996, 997, 998], 998: [996, 997, 998],
999: [999, 1000], 1000: [999, 1000],
1001: [1001],
1002: [1002],
1003: [1003],
1004: [1004],
1005: [1005],
1006: [1006],
1007: [1007],
1008: [1008],
1009: [1009],
1010: [1010],
1011: [1011],
1012: [1012],
1013: [1013],
1014: [1014],
1015: [1015],
1016: [1016],
1017: [1017],
1018: [1018],
1019: [1019],
1020: [1020],
1021: [1021],
1022: [1022],
1023: [1023],
1024: [1024],
1025: [1025],
};